// モバイル下部固定 CTA の表示制御。
// scroll が SCROLL_THRESHOLD を超えたら is-visible class を付与。
// 詳細: .spec/DESIGN-tier4-b-tier2-polish.md §4-8 / DESIGN-tier4-c-cross-ux.md §4-6
(function () {
  'use strict';
  if (typeof document === 'undefined') return;
  if (window._stickyCtaInit) return;
  window._stickyCtaInit = true;

  var SCROLL_THRESHOLD = 200;

  document.addEventListener('DOMContentLoaded', function () {
    var cta = document.querySelector('[data-sticky-cta]');
    if (!cta) return;
    document.body.classList.add('has-sticky-cta');
    function onScroll() {
      if (window.scrollY > SCROLL_THRESHOLD) {
        cta.classList.add('is-visible');
      } else {
        cta.classList.remove('is-visible');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();
